// Constante que guarda grupo de porcentajes para el maquillae de la barra de progreso
export const PROGRESSVALUES: number[] = [5, 12, 24, 36, 23];
